const classifyList = () => import('@/pages/classify/list')

export default [
  {
    path: '/classify-list',
    component: classifyList,
    name: 'classifyList',
    meta: [
      {
        name: '分类管理',
        url: '/classify-list'
      }
    ]
  }
]
